module.exports = __webpack_public_path__ + "static/img/fuzz_face.2663694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/fuzz_face.png
// module id = K1CJ
// module chunks = 12